const getMembershipRoleId = (value) => {
    if (typeof value === "string") return value;

    return (
        value?.teamRoleId ??
        value?.TeamRoleId ??
        value?.teamRole?.id ??
        value?.teamRole?.Id ??
        value?.TeamRole?.id ??
        value?.TeamRole?.Id
    );
};

const toArray = (value) => (Array.isArray(value) ? value : []);

const getValidSortOrder = (sortOrder) => {
    if (sortOrder === null || sortOrder === undefined || sortOrder === "") {
        return null;
    }

    const numericSortOrder = Number(sortOrder);
    return Number.isFinite(numericSortOrder) ? numericSortOrder : null;
};

const getEmployeeRoleIds = (employee) => {
    const membershipSources = [
        ...toArray(employee?.teamMemberships),
        ...toArray(employee?.TeamMemberships),
        ...toArray(employee?.teamMembers),
        ...toArray(employee?.TeamMembers),
        ...toArray(employee?.memberships),
        ...toArray(employee?.Memberships),
        ...toArray(employee?.teams),
        ...toArray(employee?.Teams),
    ];

    return membershipSources.map(getMembershipRoleId).filter(Boolean);
};

export const normalizeWorkloadTeamRoles = (roles) =>
    (Array.isArray(roles) ? roles : [])
        .map((role) => ({
            id: role?.id ?? role?.Id,
            name: (role?.name ?? role?.Name)?.trim(),
            sortOrder: getValidSortOrder(role?.sortOrder ?? role?.SortOrder),
            colorHex: role?.colorHex ?? role?.ColorHex,
        }))
        .filter(
            (role) =>
                role.id &&
                typeof role.name === "string" &&
                role.name.trim().length > 0,
        )
        .sort((leftRole, rightRole) => {
            const leftOrder =
                leftRole.sortOrder ?? Number.MAX_SAFE_INTEGER;
            const rightOrder =
                rightRole.sortOrder ?? Number.MAX_SAFE_INTEGER;

            return (
                leftOrder - rightOrder ||
                leftRole.name.localeCompare(rightRole.name, undefined, {
                    sensitivity: "base",
                })
            );
        });

export const getEmployeeTeamRolePriority = (employee, teamRoles = []) => {
    const roleOrdersById = new Map(
        teamRoles
            .map((role) => [String(role.id), getValidSortOrder(role.sortOrder)])
            .filter(([, sortOrder]) => sortOrder !== null),
    );

    return getEmployeeRoleIds(employee).reduce((highestPriority, roleId) => {
        const sortOrder = roleOrdersById.get(String(roleId));
        return sortOrder === undefined
            ? highestPriority
            : Math.min(highestPriority, sortOrder);
    }, Number.MAX_SAFE_INTEGER);
};

export const buildEmployeeOptions = (employees, teamRoles = []) =>
    (Array.isArray(employees) ? employees : [])
        .map((employee) => ({
            value: employee?.employeeId ?? employee?.EmployeeId,
            label: `${employee?.firstName ?? employee?.FirstName ?? ""} ${
                employee?.lastName ?? employee?.LastName ?? ""
            }`.trim(),
            is_showing: true,
            teamRolePriority: getEmployeeTeamRolePriority(employee, teamRoles),
        }))
        .filter((employee) => employee.value && employee.label)
        .sort(
            (leftEmployee, rightEmployee) =>
                leftEmployee.teamRolePriority - rightEmployee.teamRolePriority ||
                leftEmployee.label.localeCompare(rightEmployee.label, undefined, {
                    sensitivity: "base",
                }),
        );
